/* eslint-disable quotes */
import { snakelize, camelize } from "../../../helpers/object"

export default ($axios: any) => ({
  // 결제 대상 조회
  async show(data?: any) {
    return camelize(await $axios.get(`/campaign/commissions/${data.productId}`, snakelize(data)))
  },
})
